/**
 * calendarUtils — costanti e helper condivisi del Calendario.
 * ★ Fase 59.P2 — estratto da CalendarPage.jsx (split componenti oversize).
 */

import i18n from '../../i18n';

const ct = (k, d) => i18n.t(`calendarX.${k}`, d);

export const EVENT_TYPE_FILTERS = [
  { value: 'all', get label() { return ct('type.all', 'Tutti i tipi'); } },
  { value: 'appointment', get label() { return `📆 ${ct('type.appointment', 'Appuntamento')}`; } },
  { value: 'follow_up', label: '🔁 Follow-up' },
  { value: 'call_back', get label() { return `📞 ${ct('type.callBack', 'Richiamata')}`; } },
  { value: 'proposal_send', get label() { return `📄 ${ct('type.proposalSend', 'Invio proposta')}`; } },
  { value: 'milestone', label: '⭐ Milestone' },
  { value: 'other', get label() { return `📌 ${ct('type.other', 'Altro')}`; } },
];

export const RANGE_OPTIONS = [
  { value: 'today', behind: 0, ahead: 1, get label() { return ct('range.today', 'Oggi'); } },
  { value: 'week', behind: 0, ahead: 7, get label() { return ct('range.week', 'Prossimi 7 giorni'); } },
  { value: 'month', behind: 0, ahead: 30, get label() { return ct('range.month', 'Prossimi 30 giorni'); } },
  { value: 'past', behind: 7, ahead: 0, get label() { return ct('range.past', 'Ultimi 7 giorni'); } },
  { value: 'all', behind: 7, ahead: 60, get label() { return ct('range.all', 'Tutti (60gg ±)'); } },
];

export function formatDateGroup(iso) {
  const d = new Date(iso);
  const today = new Date();
  const tomorrow = new Date(today.getTime() + 86400000);
  const isSameDay = (a, b) =>
    a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
  if (isSameDay(d, today)) return ct('range.today', 'Oggi');
  if (isSameDay(d, tomorrow)) return ct('tomorrow', 'Domani');
  const locale = (i18n.language || 'it').split('-')[0];
  return d.toLocaleDateString(locale, { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
}

export function formatTime(iso) {
  return new Date(iso).toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' });
}

export function typeLabel(t) {
  return EVENT_TYPE_FILTERS.find((f) => f.value === t)?.label || t;
}
